import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { LockProvider } from "./store/LockContext";

import store from "./store/store";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LockProvider>
        <App />
      </LockProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
